import React, { useEffect, useState } from 'react'
import { allowOnlyNumbers, uptoTwoDecimalRegex } from '../../../helper/genericFunction';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import { Tooltip } from 'antd';
import Icons from '../../../assets/icons';

function AddSku(props) {

    const { getRowTolerancePerValue, initalSkuWiseBoxesData } = props;

    console.log("Initial Sku wise boxes data", initalSkuWiseBoxesData);

    const [skuWiseBoxesBackup, setSkuWiseBoxesBackup] = useState(JSON.parse(JSON.stringify(props?.skuWiseBoxes)));

    const closeAndReset = () => props?.discardAddSKUModal(skuWiseBoxesBackup);

    const submit = () => {
        props?.submit();
        props?.close();
    }

    const small = (str) => {
        if (str != null) {
            var str = str.toString()
            if (str.length <= 30) return false;
            return true;
        }
    }
    const selectedSKUCount = props?.skuWiseBoxes && Object.values(props?.skuWiseBoxes).filter(item => item?.[props?.boxIndex] !== null)?.length;
    const someInvalidInput = props?.poDetails?.some(item => +(props?.skuWiseBoxes?.[item?.id]?.[props?.boxIndex]) > (+(skuWiseBoxesBackup?.[item.id]?.[props?.boxIndex]) + +(item?.setPendingQty) + getRowTolerancePerValue(item)));

    return (
        <React.Fragment>
            <div className="big-add-sku min-h-[300px] h-full flex flex-col">
                <div className="bigas-top">
                    <div className="bigast-left">
                        <LanguageTranslator tag='h3'>Add SKU's</LanguageTranslator>
                    </div>
                    <div className="bigast-right flex items-center gap-3">
                        <GenericCustomButton type='default' onClick={()=> closeAndReset()} label="Discard" />
                        <GenericCustomButton type='primary' disabled={selectedSKUCount === 0 || someInvalidInput} label="Done" onClick={()=> submit()} />
                    </div>
                </div>
                <div className="bigas-body !pb-0 h-full overflow-auto flex-1 flex flex-col">
                    <div className="create-price-list-table act-table flex-1 !flex flex-col">
                        <div className="cplt-manage flex-1 flex flex-col overflow-auto">
                            <table className="table">
                                <thead className='sticky top-0 w-full z-10'>
                                    <tr>
                                        <th></th>
                                        <th><label>Requested quantity</label></th>
                                        {/* <th><label>Pending quantity</label></th> */}
                                        {Object.keys(props?.headersData?.[props?.headersType] || {}).map(key =>
                                            <th key={key}>
                                                <label>{props?.headersData[props?.headersType][key]}</label>
                                            </th>)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {props?.poDetails.map((item, index) => {
                                        const invalidInput = Number(props?.skuWiseBoxes?.[item.id]?.[props?.boxIndex]) > Number(skuWiseBoxesBackup?.[item.id]?.[props?.boxIndex]) + item?.setPendingQty + getRowTolerancePerValue(item);

                                        // Check the condition for the item being removed which was added before and the user cannot remove it now
                                        const canQtyBeZero = initalSkuWiseBoxesData?.skuWiseBoxes?.[item.id]?.[props?.boxIndex] ? false : true
                                        const isQtyIsZero = Number(props?.skuWiseBoxes?.[item.id]?.[props?.boxIndex]) == 0 ? true : false;

                                        if (props?.isEdit) {
                                            if (props?.skuWiseBoxes?.[item.id]?.[props?.boxIndex] || +(item?.shipmentRequestedQty) > 0) {
                                                return (
                                                    <tr key={item.id}>
                                                        <td className="fix-action-btn width40">
                                                            <ul class="table-item-list">
                                                                <li class="til-inner">
                                                                    <label class="checkBoxLabel0">
                                                                        <input data-sku={item.id} disabled={item?.isPoItemHold || item?.tnaCompleted===false} type="checkbox" checked={!canQtyBeZero || props?.skuWiseBoxes?.[item.id]?.[props?.boxIndex] !== null && props?.skuWiseBoxes?.[item.id]?.[props?.boxIndex] !== undefined} />
                                                                        <span class="checkmark1"></span>
                                                                    </label>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                        <td>
                                                            <input type="text" disabled={item?.isPoItemHold || item?.tnaCompleted===false || item.initialAvaliableQty == 0} className={invalidInput ? "errorBorder" : ""} data-sku={item.id} value={+(props?.skuWiseBoxes?.[item.id]?.[props?.boxIndex]) || ""} onChange={(e) => (item.qtyInputType == "D" ? uptoTwoDecimalRegex(e.target.value) : allowOnlyNumbers(e.target.value)) && props?.handleSKUWiseInput(e)} />
                                                            {item.initialAvaliableQty == 0 && <span className="table-tooltip">Quantity fully utilized.</span>}
                                                            {invalidInput ? <span className="table-tooltip">Requested Qty must be less than {+(skuWiseBoxesBackup?.[item.id]?.[props?.boxIndex]) + +(item.setPendingQty) + getRowTolerancePerValue(item)}</span> : ((isQtyIsZero && !canQtyBeZero) && <span className="table-tooltip">This SKU cannot be deselected at the edit shipment.</span>)}
                                                        </td>
                                                        {/* <td><label>{item.setPendingQty}</label></td> */}
                                                        {Object.keys(props?.headersData[props?.headersType]).map(key =>
                                                            <td key={key}>
                                                                <label>{item[key]}</label>
                                                                {small(item[key]) && <div className="table-tooltip"><label>{item[key]}</label></div>}
                                                            </td>)}
                                                    </tr>
                                                )
                                            }
                                        }
                                        else {
                                            return (
                                                <tr key={item.id}>
                                                    <td className="fix-action-btn width40">
                                                        <ul class="table-item-list">
                                                            <li class="til-inner">
                                                                <label class="checkBoxLabel0">
                                                                    <input data-sku={item.id} type="checkbox" disabled={item?.isPoItemHold || item?.tnaCompleted===false} checked={props?.skuWiseBoxes?.[item.id]?.[props?.boxIndex] !== null} />
                                                                    <span class="checkmark1"></span>
                                                                </label>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                    <td>
                                                        <input type="text" disabled={item?.isPoItemHold || item?.tnaCompleted===false || item.initialAvaliableQty == 0} className={invalidInput ? "errorBorder" : ""} data-sku={item.id} value={props?.skuWiseBoxes?.[item.id]?.[props?.boxIndex] || ""} onChange={(e) => (item.qtyInputType == "D" ? uptoTwoDecimalRegex(e.target.value) : allowOnlyNumbers(e.target.value)) && props?.handleSKUWiseInput(e)} />
                                                        {item.initialAvaliableQty == 0 && <span className="table-tooltip">Quantity fully utilized.</span>}
                                                        {invalidInput && <span className="table-tooltip">Requested Qty must be less than {+(skuWiseBoxesBackup[item.id][props?.boxIndex]) + item.setPendingQty + getRowTolerancePerValue(item)}</span>}
                                                    </td>
                                                    {/* <td><label>{item.setPendingQty}</label></td> */}
                                                    {Object.keys(props?.headersData[props?.headersType]).map(key =>{
                                                       return  <td key={key}>
                                                           { (key==="itemCode" || key==="setBarCode") && (item?.isPoItemHold) ? 
                                                            <label className='flex gap-2'>
                                                                {item[key]} 
                                                                 <Tooltip title="on Hold" color='yellow'>
                                                                     <Icons.FilePlusIcon />
                                                                 </Tooltip> 
                                                            </label>:
                                                            (key==="itemCode" || key==="setBarCode") && (item?.tnaCompleted===false) ? 
                                                            <label className='flex gap-2'>
                                                                {item[key]} 
                                                                 <Tooltip title="TNA Pending" color='red'>
                                                                     <Icons.TnaIcon />
                                                                 </Tooltip> 
                                                            </label> 
                                                            :<label>{item[key]}</label>}
                                                            {small(item[key]) && <div className="table-tooltip"><label>{item[key]}</label></div>}
                                                        </td>})}
                                                </tr>
                                            );
                                        }
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="new-gen-pagination">
                            <div className="ngp-left">
                                <div className="table-page-no">
                                    <span className='skut-text'>Total SKU's Selected: </span>
                                    <span class="bold">{selectedSKUCount}</span>
                                    <span class="ngp-total-item skut-text">Total SKU's Available: </span>
                                    <span class="bold">{props?.poDetails?.length}</span>
                                </div>
                            </div>
                            <div className="ngp-right">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddSku